module.exports = __webpack_public_path__ + "img/wp-new-habit-card11.80e5aabe.jpg";